<template>
  <ClientOnly>
    <div
      v-if="count > 0"
      class="absolute bottom-0 right-[-5px] box-content flex size-4 items-center justify-center rounded-full bg-orange-500 pt-px"
    >
      <span class="text-sm text-white">
        {{ count }}
      </span>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { ClientOnly } from '#components'

interface Props {
  count: number
}

defineProps<Props>()

defineOptions({
  name: 'HeaderBadge',
})
</script>
